import { render } from "./ProjectsTab.vue?vue&type=template&id=029b1aa0"
import script from "./ProjectsTab.vue?vue&type=script&lang=js"
export * from "./ProjectsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__